import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Records/hooks/useRecordTags.ts
var testData = {
	records: [
		{
			category: "Category 1",
			color: "#e5e367",
			id: "AT_001",
			level: 1,
			title: "Activity Type 1"
		},
		{
			category: "Category 2",
			color: "#3086ea",
			id: "AT_002",
			level: 2,
			title: "Activity Type 2"
		},
		{
			category: "Category 3",
			color: "#12ff89",
			id: "AT_003",
			level: 3,
			title: "Activity Type 3"
		}
	],
	total: 3
};
function useRecordTags(args, opts = {}) {
	const { data, isCalling } = useRPC(RPCs.Records.GetRecordTagsList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		testData
	});
	return {
		data,
		loading: isCalling
	};
}
//#endregion
export { useRecordTags };

//# sourceMappingURL=useRecordTags.js.map